<div class="generate-invest-cash-rebalance-settings">

  <div class="flex-row">
    <div class="flex-column flex-column-header">
      <strong>Invest Cash </strong>
    </div>
    <div class="flex-column">
      <div class="checkboxes-horizontal-align">
        <div class="flex-radio-item">
          <p-radioButton name="cashGroup" inputId="securities" value="Securities"
             [(ngModel)]="investCashSetting" (ngModelChange)="onCashChange()" [disabled]="isReadOnly"></p-radioButton>
          <label for="securities">Underweight positions</label><span class="tooltipIcon infoIcon" calltoaction
                                                               [calltoactionTemplate]="investCashUnderWeightToolTipIcon"></span>
        </div>
        <div class="flex-radio-item">
          <p-radioButton name="cashGroup" inputId="modelSecurities" value="ModelSecurities"
             [(ngModel)]="investCashSetting" (ngModelChange)="onCashChange()" [disabled]="isReadOnly"></p-radioButton>
          <label for="modelSecurities">All model positions</label><span class="tooltipIcon infoIcon" calltoaction
                                                                   [calltoactionTemplate]="investCashAllModelToolTipIcon"></span>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #investCashUnderWeightToolTipIcon>
  <div class="tooltip-body">When cash exceeds the target, iRebal prioritizes positions that are underweight relative to the model and generates potential buy orders to move them toward their targets.</div>
</ng-template>
<ng-template #investCashAllModelToolTipIcon>
  <div class="tooltip-body">When cash exceeds the target, iRebal allocates it across all model positions proportionally based on their target weights.</div>
</ng-template>

